import { render, staticRenderFns } from "./siderbarItem.vue?vue&type=template&id=0027a4d9"
import script from "./siderbarItem.vue?vue&type=script&lang=js"
export * from "./siderbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports